<template>
  <div class="map-links">
    <h3>Map Features</h3>
    <div class="map-links-grid">
      <router-link v-if="isAuthenticated" to="/search-map" class="map-link">
        <div class="map-link-content">
          <h4>Utah Map</h4>
          <p>View the basic Utah map</p>
        </div>
      </router-link>
      <div v-else class="map-link auth-required">
        <div class="map-link-content">
          <h4>Utah Map</h4>
          <p>Please sign in to access the map</p>
          <button class="btn btn-primary mt-2" @click="$emit('showSignin')">Sign In</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MapLinks',
  computed: {
    ...mapGetters(['isAuthenticated'])
  }
}
</script>

<style scoped>
.map-links {
  margin: 2rem 0;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.map-links h3 {
  margin-bottom: 1rem;
  text-align: center;
}

.map-links-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.map-link {
  display: block;
  padding: 1rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  text-decoration: none;
  color: inherit;
  transition: transform 0.2s, box-shadow 0.2s;
}

.map-link:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.map-link-content h4 {
  margin-top: 0;
  color: #007bff;
}

.map-link-content p {
  margin-bottom: 0;
  color: #6c757d;
}

.auth-required {
  background-color: #f8f9fa;
  border: 1px dashed #dee2e6;
  padding: 1rem;
  border-radius: 4px;
  text-align: center;
}
</style>
